import React from 'react';
import { Link } from 'gatsby';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';
import moment from 'moment';

const NewsHome = () => {
  const query = graphql`
    {
      allStrapiBlogs(limit: 3, sort: { fields: date, order: DESC }) {
        nodes {
          id
          slug
          image {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
          date
          title
          category
        }
      }
    }
  `;
  const data = useStaticQuery(query);

  const {
    allStrapiBlogs: { nodes },
  } = data;

  return (
    <section className='blog-one blog-one__home thm-gray-bg' id='news'>
      <div className='container'>
        <div className='block-title text-center'>
          <h2 className='block-title__title'>
            Latest Blogs & Articles
          </h2>
        </div>
        <div className='row'>
          {nodes?.map((node) => {
            return (
              <div
                className='col-lg-4 col-md-12 col-sm-12 wow fadeInUp'
                data-wow-duration='1500ms'
                key={node.id}
              >
                <div className='blog-one__single'>
                  <div className='blog-one__image'>
                    <Image
                      fluid={node.image.childImageSharp.fluid}
                      alt={node.title}
                    />
                    <Link
                      to={`/blog/${node.category}/${node.slug}`}
                      className='blog-one__more-link'
                    >
                      <i className='fa fa-link'></i>
                    </Link>
                  </div>
                  <div className='blog-one__content'>
                    <ul className='list-unstyled blog-one__meta'>
                      <li>
                        <a href='#none'>
                          {moment(node.date).format('DD MMM, YYYY')}
                        </a>
                      </li>
                    </ul>
                    <h3 className='blog-one__title'>
                      <Link to={`/blog/${node.category}/${node.slug}`}>
                        {node.title}
                      </Link>
                    </h3>
                    <Link
                      to={`/blog/${node.category}/${node.slug}`}
                      className='blog-one__link'
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className='d-flex justify-content-center align-items-center'>
          <Link to={'/blog'} className='banner-two__btn thm-btn blog-one__link'>
            <span>View All</span>
          </Link>
        </div>
      </div>
    </section>
  );
};
export default NewsHome;
